import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_autoplay",
  "use": "icon-icon_autoplay-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_autoplay\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" stroke-width=\"3\" cx=\"22\" cy=\"22\" r=\"20.5\" /><path d=\"m27.504 23.664-6.395 4.263A2 2 0 0 1 18 26.263v-8.526a2 2 0 0 1 3.11-1.664l6.394 4.263a2 2 0 0 1 0 3.328Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol